import { connect } from 'react-redux';
import { PaginatedLogsTable } from '../PaginatedLogsTable';
import { getPaginatedUserLogs } from '../../actions/users';

const mapDispatchToProps = {
  update: getPaginatedUserLogs,
};

const mapStateToProps = ({ users }) => ({
  paginatedLogs: users.selectedPaginatedUserLogs,
  isLoading: users.loadingUserLogs,
});

export const UserLogsTable = connect(mapStateToProps, mapDispatchToProps)(PaginatedLogsTable);

export default UserLogsTable;
